<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
            <v-card-text>Are you sure you want to remove this code ?</v-card-text>
            <v-divider></v-divider>
            <v-card-text>{{ akcc.akcc_regel }}</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="warning mx-2" small @click="rmAkcc">Yes</v-btn>
                <v-btn color="success"  small @click="dialog = false">No</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,
                akcc: {
                    akcc_regel: ""
                }
            }
        },
        methods: {
            openDialog(akcc) {
                this.akcc = akcc
                this.dialog = true;
            },
            rmAkcc() { 
                this.$axios.post("ares/json/ares/syst/ref/akcd/rmAkccv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "rmAkccv2"
                    },
                    rmAkccv2: {
                        akcc_encrid: this.akcc.akcc_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else { 
                        // this.$router.reload('/syst/ref/akcd/searchAkcd/'); 
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.rmAkccv2.text,
                            color: res.data.rmAkccv2.color
                        });
                        this.$emit("deletedAkcc", this.akcc.akcc_encrid)
                        this.dialog = false;
                    }
                })
            },
        }   
    }
</script>

